import { FC, useEffect, useState }  from 'react';
import { agora } from '../../../environments/voice-call-variables';
import Videocall from "@fc/videocall/Videocall/videocall";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@redux/store';
import { IJoinArgs } from '@interfaces/videocall/videocall';
import useVideoCallSocket from '@customHooks/video-call/use-videocall-socket';
import { setCleanVideoCall } from '@redux/slices/video-call/video-call.slice';
import { setVideoAlert, setVideoCallInProcess } from '@redux/slices/video-call/videoCall-alert.slice';
import { setAnswered } from '@redux/slices/video-call/video-call.slice';
import { deleteVideoCallStartData } from '@services/videocall/videoCallService';

interface IVideocallWrapper
{
    onCreateSocketVideo: () => void,
    expired: boolean,
    resetStates: () => void
}

const VideocallWrapper: FC<IVideocallWrapper> = (props) => {
    const session = useSelector((state: RootState) => state.session);
    const currentVideoCall = useSelector((state: RootState) => state.videoCall.videoCall);
    const videoCallAlert = useSelector((state: RootState) => state.videoAlert);
    const audioDefault = videoCallAlert.videoAlert.audioEnabled;
    const videoDefault = videoCallAlert.videoAlert.videoEnabled;
    const appointment = useSelector((state: RootState) => state.newAppointment);

    const [controlsValues, setControlsValues] = useState<IJoinArgs>();
    const [username, setUsername] = useState<string>();

    const [token, setToken] = useState<string>();


    const { emitSocketVideoEvent } = useVideoCallSocket();
    const dispatch = useDispatch();

    useEffect(() => {
        try
        {
            if(!currentVideoCall) return
            const tempUsername = currentVideoCall?.nameEmit === session.username ? currentVideoCall.name : currentVideoCall?.nameEmit;
            setUsername(tempUsername);
            setToken(currentVideoCall?.token)
        }
        catch(error)
        {
            console.warn("Could not set username", error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentVideoCall]);

    useEffect(() => {
        // setCounterState(counterState + 1);
        if(session.username)
        {
            // Generate socket video
            props.onCreateSocketVideo();
        }
        else if(videoCallAlert.videoAlert.videoCallInProgress)
        {
            leaveVideocall();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session.username]);

    useEffect(() => {
        if(audioDefault === undefined || videoDefault === undefined)
            return;
        setControlsValues({
            audio: audioDefault,
            video: videoDefault
        });
    }, [audioDefault, videoDefault]);

    /**
     * Clean redux videocall data
     */
    const leaveVideocall = () => {
        if( !appointment.isAppointment){
            dispatch(setCleanVideoCall());
        }
        dispatch(setVideoCallInProcess({videoCallInProgress: false}));
        
        //For socket emit leave
        const listener = {
            username: null,
            newVideoCall: false
        }
        dispatch(setVideoAlert(listener))
        dispatch(setAnswered(false))
        if(currentVideoCall)
        {
            emitSocketVideoEvent("leave_call", {
                name: currentVideoCall.name,
                id: currentVideoCall.id,
                token: currentVideoCall.token,
                room: currentVideoCall.room,
                idEmit: currentVideoCall.idEmit,
            });
            deleteVideoCallStartData(currentVideoCall.room)
                .then(() => console.debug(`Video call room ${currentVideoCall.room} deleted`))
                .catch(err => console.error(`Could not delete number for room ${currentVideoCall.room}`, err))
            dispatch(setVideoCallInProcess({videoCallInProgress: false}));
            // dispatch(setCleanVideoCall());
        }
    }

    const onUserPublished = () => {
        console.debug("User published")
        dispatch(setAnswered(true))
    }

    const onUserLeft = () => {
        console.debug("User published")
        dispatch(setAnswered(false))
    }

    useEffect(() => {
        if(!props.expired) return
        leaveVideocall()
        props.resetStates()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.expired, props.resetStates])

    const checkAvailable = () => {
        const res = controlsValues !== undefined && 
            username !== undefined && 
            session.username !== undefined &&
            videoCallAlert.videoAlert.videoCallInProgress === true && 
            currentVideoCall?.room !== undefined && 
            currentVideoCall?.token !== undefined;

        // console.groupCollapsed("Check values");
        // console.log("controlsValues", controlsValues);
        // console.log("username", username);
        // console.log("session.username", session.username);
        // console.log("videoCallAlert.videoAlert.videoCallInProgress", videoCallAlert.videoAlert.videoCallInProgress);
        // console.log("currentVideoCall?.room", currentVideoCall?.room);
        // console.log("currentVideoCall?.token", currentVideoCall?.token);
        // console.groupEnd();

        // console.log(res);

        return res;
    }

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {  
                checkAvailable() && controlsValues !== undefined && session.username && token &&
                <Videocall 
                    appId={agora.appID}
                    channelName={currentVideoCall?.room || ""}
                    token={token}
                    initialMediaArgs={controlsValues}
                    incomingUsername={username || ""}
                    username={session.username}
                    onLeaveChannel={leaveVideocall}
                    onUserJoined={onUserPublished}
                    onUserUnJoined={onUserLeft}
                >
                    <span>Avatar</span>
                </Videocall>
            }
        </>
    )
}

export default VideocallWrapper;
